import { flow } from 'fp-ts/function';
import { get, isEqual, isNil, negate } from 'lodash/fp';
import { createSelector } from 'reselect';

import { PaymentCard3DsAuthorizationState } from '@mews/enums';
import { getOrEmptyObject, getOrFalse, getStringProp } from '@mews/fp';

import { ApplicationState } from '../../../types';
import { WithPaymentCardId } from '../../../types/selectors/selectorPropTypes';
import { getEntities } from '../getEntities';
import { Entities } from '../types';
import { PaymentCard, PaymentCards, PaymentCardsData } from './types';

const getPaymentCardsEntity = createSelector<ApplicationState, Entities, PaymentCards>(
    getEntities,
    get('paymentCards')
);

const getPaymentCardsData = createSelector<ApplicationState, PaymentCards, PaymentCardsData>(
    getPaymentCardsEntity,
    get('data')
);

const getPaymentCardsMeta = createSelector(getPaymentCardsEntity, getOrEmptyObject('meta'));

export const arePaymentCardsFetching = createSelector(getPaymentCardsMeta, getOrFalse('isFetching'));

const getPaymentCard = createSelector<
    ApplicationState,
    WithPaymentCardId,
    string,
    PaymentCardsData,
    PaymentCard | undefined
>(getStringProp('paymentCardId'), getPaymentCardsData, get);

const getPaymentCardAuthorizationState = flow<
    [ApplicationState, WithPaymentCardId],
    PaymentCard | undefined,
    PaymentCard3DsAuthorizationState | undefined
>(getPaymentCard, get('authorizationState'));

export const isPaymentCardAuthorizable = flow(
    getPaymentCardAuthorizationState,
    isEqual(PaymentCard3DsAuthorizationState.Authorizable)
);

export const hasPaymentCardId = flow(getPaymentCard, negate(isNil));
